import { render } from "./FrisbuySrArrow.vue?vue&type=template&id=8d50a7d4&scoped=true"
import script from "./FrisbuySrArrow.vue?vue&type=script&lang=js"
export * from "./FrisbuySrArrow.vue?vue&type=script&lang=js"

import "./FrisbuySrArrow.vue?vue&type=style&index=0&id=8d50a7d4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d50a7d4"]])

export default __exports__